import { combineReducers } from "redux";

import { ITrack } from "../api";
import { RootAction } from "../types";

export interface IPageInfo {
  ids: string[],
  loading: boolean,
}

function pages(state: IPageInfo[] = [], action: RootAction): IPageInfo[] {
  let page: number;
  switch (action.type) {
    case 'FETCH_TRACKS_REQUEST':
      page = action.meta.page;
      state[page] = {
        ids: [],
        loading: true,
      };
      return state;

    case 'FETCH_TRACKS_FAILURE':
      page = action.meta.page;
      state[page] = {
        ids: [],
        loading: false,
      };
      return state;

    case 'FETCH_TRACKS_SUCCESS':
      const {tracks} = action.payload;
      page = action.meta.page;
      state[page] = {
        ids: tracks.map((track: ITrack) => track.id),
        loading: false,
      };
      return state;

    default:
      return state;
  }
}

function total(state: number | null = null, action: RootAction): number | null {
  switch (action.type) {
    case 'FETCH_TRACKS_SUCCESS':
      return action.payload.total;

    default:
      return state;
  }
}

function data(state: {[k: string]: ITrack} = { }, action: RootAction): {[k: string]: ITrack} {
  let track: ITrack;
  switch (action.type) {
    case 'FETCH_TRACK_SUCCESS':
      track = action.payload;
      return {
        ...state,
        [track.id]: track,
      };
    
    case 'UPDATE_TRACK_SUCCESS':
      track = action.payload;
      return {
        ...state,
        [track.id]: track,
      };

    case 'FETCH_TRACKS_SUCCESS':
      const newState = { ...state };
      const {tracks} = action.payload;
      tracks.forEach((t) => {
        newState[t.id] = t;
      });
      return newState;

    default:
      return state;
  }
}

export const tracksReducer = combineReducers({
  data,
  pages,
  total,
});
export default tracksReducer;



// WEBPACK FOOTER //
// ./src/reducers/tracksReducer.ts